<div class="affiliate_page_wrap">
    <div class="affiliate_top_banners">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="affi_top_contents">
                        <h1>
                            <span class="OpenSansFonts">Trinka</span>を紹介して、広告収入を！</h1>
                        <a id="signUpAtShareASale" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            アフィリエイトプログラムに参加する
                            <br>（ShareASaleに登録）
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="who_we_are_sections">
        <div class="container">
            <div class="row column_reverse">
                <div class="col-lg-12">
                    <div class="whot_we_are_content">
                        <h2>
                            <span class="OpenSansFonts">Trinka</span>アフィリエイトプログラムについて</h2>
                            <div class="HeadingSubLine"></div>

                        <p>
                            <span class="OpenSansFonts">Trinka</span>（トリンカ）アフィリエイトプログラムは、シンプルで効率的です。アフィリエイターのウェブサイト（またはソーシャルメディアのプロフィール、メール、電子書籍など）に貼られたバナーまたはトラッキングテキストリンクをクリックした各ユーザーがTrinkaのプレミアムプランを購入するたびに報酬が支払われます。無料ツールのため、アフィリエイターは押しつけがましい売り込みをしなくても多くの収入が期待できます。また、単なる紹介でも十分ですが、トップアフィリエイターになれば、さらに高い報酬を得ることができます。</p>
                        <p>お問い合わせは、
                            <a href="mailto:marketing@trinka.ai">marketing@trinka.ai</a>までお願いします。
                        </p>
                    </div>
                </div>

            </div>

        </div>
    </div>
    <div class="benefits_sections">
        <div class="benefits_outer">
            <div class="commission_sections">
                <div class="commission_header">
                    <img src="../../../assets/images/CommisionDetails.png" alt="手数料の詳細 - 文法 チェック">
                    <h2>お支払いする
                        <br>報酬</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <!-- <li>無料新規ユーザー登録：$0.30/件</li> -->
                        <li>プレミアムプラン購入：25%/件</li>
                    </ul>
                </div>
            </div>

            <div class="commission_sections OtherBenefits_section">
                <div class="commission_header">
                    <img src="../../../assets/images/otherBenefits.png" alt="その他の利点 - 英文校正">
                    <h2>その他の利点</h2>
                </div>
                <div class="commission_body">
                    <ul>
                        <li>高いコンバージョン率</li>
                        <li>クロスデバイス・トラッキング(PC・スマホ対応)</li>
                        <li>クッキーの有効期限：90 日間</li>
                        <li>先行参加特典あり</li>
                        <li>初心者でも安心のサポート体制</li>
                    </ul>
                </div>
            </div>

        </div>
        <!-- <div class="container">
            <div class="row">
                <div class="col-md-2"></div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Commision Details</h2>
                        <ul>
                            <li>Free Sign-ups - $0.21</li>
                            <li>Paid plan subscription - $20</li>
                        </ul>
                    </div>
                </div>
                <div class="col-lg-4">
                    <div class="benefits_cards">
                        <h2>Other Benefits</h2>
                        <ul>
                            <li>Great conversion rates (20-30%)</li>
                            <li>Cross-device tracking</li>
                            <li>Extended 90-day cookie window</li>
                            <li>Early bird rewards</li>
                            <li>Top-class affiliate support</li>
                        </ul>
                    </div>
                </div>
                <div class="col-md-2"></div>
            </div>
        </div> -->
    </div>


    <div class="why_become_affiliate_sectioin">
        <div class="container">
            <div class="row">
                <div class="col-md-9">
                    <h2>
                        <span class="OpenSansFonts">Trinka</span>のアフィリエイトがおすすめな理由</h2>
                        <div class="HeadingSubLine"></div>
                    <p>文法や文章の校正は非常に複雑で、ほとんどのオンライン英文校正ツールは、学術論文やテクニカルライティングの校正にはむいていません。数十年にわたる業界での実績とAIおよび機械学習テクノロジーを活用した
                        <span
                            class="OpenSansFonts">Trinka</span>（トリンカ）は、ミスのない技術文書・学術論文を書くための提案を行います。ベーシックプランは完全に無料で、ブラウザのプラグインやMS Wordのプラグインとして、オンラインで使用することができます。</p>
                    <p>
                        <span class="OpenSansFonts">Trinka</span>のパートナーになれば、学術関係者や教育機関の人々にメリットをもたらすだけでなく、最小限の労力で安定した収益が期待できます。
                        <span class="OpenSansFonts">Trinka</span>はツール業界でもトップレベルの精度があるため、アフィリエイターの皆様は、最新コンテンツや推奨事項の紹介と、新規顧客獲得に専念していただけます。</p>
                </div>
                <div class="col-md-3">
                    <div class="affiliate_img">
                        <img src="../../../assets/images/anAffiliate.png" alt="アフィリエイト - 英文 チェック ai">
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="Affiliate_FAQ_Seciton">
        <div class="container">
            <div class="row">
                <div class="col-md-12">
                    <div class="faq_affiliate_sections">
                        <h2>FAQ</h2>
                        <div class="HeadingSubLine"></div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div id="accordion">

                        <div class="card">
                            <div class="card-header" id="heading-1">
                                <h5 class="mb-0">
                                    <a role="button" data-toggle="collapse" href="#collapse-1" aria-expanded="true" aria-controls="collapse-1">
                                        どんな人が
                                        <span class="OpenSansFonts">Trinka</span>のアフィリエイトプログラムに適していますか？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-1" class="collapse show" data-parent="#accordion" aria-labelledby="heading-1">
                                <div class="card-body">
                                    <p>
                                        <span class="OpenSansFonts">Trinka</span>（トリンカ）は、学生、研究者、科学者、専門家、語学愛好家など、英語で文章を書く世界中のすべての人を対象とした英文校正ツールです。ですから
                                        <span
                                            class="OpenSansFonts">Trinka</span>のアフィリエイトプログラムは、ライティングに関連するウェブサイトやブログを運営している方に最適です。さらに、教育や科学、テクノロジー、キャリア開発など、
                                        <span
                                            class="OpenSansFonts">Trinka</span>のユーザー層にアピールするコンテンツをお持ちの方は有利にプログラムを進められるでしょう。</p>
                                    <p>
                                        <span class="OpenSansFonts">Trinka</span>のミッションに合致したコンテンツを作成し、関連性の高い最新情報が適切な形で掲載していれば、報酬を得られる可能性は高いでしょう。</p>

                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-3">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-3" aria-expanded="false" aria-controls="collapse-3">
                                        <span class="OpenSansFonts">Trinka</span>のアフィリエイトプログラムはどうやって始められますか？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-3" class="collapse" data-parent="#accordion" aria-labelledby="heading-3">
                                <div class="card-body">
                                    <p>アフィリエイトプログラムにご参加いただいた方に、運営されているブログやウェブサイトに掲載いただくためのアフィリエイトバナーやリンクをお送りします。また、ニュースレターやメールを利用して、Trinka（トリンカ）を宣伝いただくことも可能です。</p>
                                    <p>バナーやリンクを貼るのは、価値のある内容の適切なコンテンツのページにしていただくようお願いしています。他のバナーやリンクと一緒に貼ることもお断りしています。</p>
                                    <p>また、登録するユーザーに、インセンティブや報酬を供与することは固く禁じております。</p>
                                    <p>さらに、商標である「Trinka」や「Trinka.ai」、またはこれらに類した表記（誤ったスペルを含む）のリスティング広告の入札もお断りします。これら商標名をドメイン名やメタタグに使用したり、PPC広告（クリック課金型広告）から直接当社のウェブサイトにリンクしたりすることもご遠慮ください。</p>
                                    <p style="margin: 0;">また、以下のようなブランド名、およびそれ以外のキーワードの入札も禁止します。</p>
                                    <p>Trinka、Trinka AI、trinka.ai、www.trinka.ai、盗用・剽窃チェッカー、<a href="/grammar-checker" class="text-link">文法チェッカー</a>、<a href="/grammar-checker" class="text-link">文法チェック</a>、盗用・剽窃チェック、無料盗用・剽窃チェッカー、文法チェッカー無料、オンライン文法チェッカー、ライティングアシスタント、アカデミックライティングアシスタント、テクニカルライティングアシスタント、プルーフリーディング、校正・校閲</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-4">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-4" aria-expanded="false" aria-controls="collapse-4">
                                        <span class="OpenSansFonts">Trinka</span>のアフィリエイトプログラム参加のメリットは何ですか？
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-4" class="collapse" data-parent="#accordion" aria-labelledby="heading-4">
                                <div class="card-body">
                                    <p>アフィリエイターの皆様のウェブサイト上のすべてのリンクには、特定のトラッキングコードが設定されます。各ユーザーがそれを通じてTrinka（トリンカ）のウェブサイトにアクセスし、Trinkaのプレミアムプランを購入するたびに、アフィリエイトプログラムの運用に使用するツールShareASaleがそのコンバージョンを記録し、アフィリエイターのアカウントに割り当てます。そしてTrinkaのプレミアムプラン購入1件につき25%を報酬（手数料）としてお支払いします。コンバージョン数や報酬は、ShareASaleのダッシュボードやレポートセクションから、いつでも確認することができます。ShareASaleの設定するCookieの有効期限は90日間と長いため、長期にわたりコンバージョンを記録することができます。</p>
                                    <p>
                                        <strong>注意事項：</strong>すべてのお支払いは米ドルのみで行われます。米国以外にお住まいの方は、ドル建ての口座をご用意ください。</p>
                                </div>
                            </div>
                        </div>

                        <div class="card">
                            <div class="card-header" id="heading-5">
                                <h5 class="mb-0">
                                    <a class="collapsed" role="button" data-toggle="collapse" href="#collapse-5" aria-expanded="false" aria-controls="collapse-5">
                                        <span class="OpenSansFonts">Trinka</span>アフィリエイトプログラムの取引条件を教えてください
                                    </a>
                                </h5>
                            </div>
                            <div id="collapse-5" class="collapse" data-parent="#accordion" aria-labelledby="heading-5">
                                <div class="card-body">
                                    <p>取引条件に関しては、
                                        <a href="https://www.trinka.ai/termsofservices/" target="_blank">リンク先</a>をご覧ください。</p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12 text-center">
                    <div class="bottom_shareAsale_buttons">
                        <a id="signUpAtShareASaleFooter" href="https://www.shareasale.com/shareasale.cfm?merchantID=98815" target="_blank">
                            <i class="fa fa-sign-in"></i>
                            アフィリエイトプログラムに参加する
                            <br> （ShareASaleに登録）
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>